import script from "./moneyManage.vue?vue&type=script&setup=true&lang=js"
export * from "./moneyManage.vue?vue&type=script&setup=true&lang=js"

import "./moneyManage.vue?vue&type=style&index=0&id=88054fc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88054fc0"]])

export default __exports__